import "@fortawesome/fontawesome-pro/css/all.css";
import "./views/index.scss";
import React from "react";
import ReactDOM from "react-dom";
import App from "./views/App";
import {setupAxiosCache} from "./services/AxiosCache";

setupAxiosCache();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
